import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserBadges } from '../../actions/badgeActions';
import { Award } from 'lucide-react';

const RARITY_COLORS = {
  bronze: '#CD7F32',
  silver: '#C0C0C0',
  gold: '#FFD700',
  platinum: '#E5E4E2'
};

const BadgesTab = ({ userId }) => {
  const dispatch = useDispatch();
  const { userBadges, loading } = useSelector(state => state.badge);

  useEffect(() => {
    if (userId) dispatch(getUserBadges(userId));
  }, [dispatch, userId]);

  if (loading) {
    return (
      <div className="space-y-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="h-20 bg-gray-100 rounded-lg animate-pulse" />
        ))}
      </div>
    );
  }

  if (!userBadges || userBadges.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        <Award className="w-12 h-12 mx-auto mb-3 opacity-40" />
        <p className="text-lg font-medium">No badges earned yet</p>
        <p className="text-sm mt-1">Complete courses and lessons to earn badges!</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-[#054581]">Badges ({userBadges.length})</h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {userBadges.map(ub => {
          const badge = ub.badge;
          if (!badge) return null;
          const rarityColor = RARITY_COLORS[badge.rarity] || RARITY_COLORS.bronze;
          return (
            <div key={ub._id} className="flex flex-col items-center p-4 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md transition-shadow">
              {badge.image ? (
                <img
                  src={badge.image}
                  alt={badge.title}
                  className="w-16 h-16 rounded-full object-cover mb-2"
                  style={{ borderColor: rarityColor, borderWidth: '3px', borderStyle: 'solid' }}
                />
              ) : (
                <div
                  className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mb-2"
                  style={{ borderColor: rarityColor, borderWidth: '3px', borderStyle: 'solid' }}
                >
                  <Award className="w-7 h-7 text-gray-400" />
                </div>
              )}
              <h4 className="text-sm font-semibold text-[#054581] text-center">{badge.title}</h4>
              <span
                className="inline-block px-2 py-0.5 rounded-full text-[10px] font-bold uppercase mt-1"
                style={{ backgroundColor: rarityColor, color: '#333' }}
              >
                {badge.rarity}
              </span>
              <p className="text-[10px] text-gray-400 mt-1">
                {new Date(ub.earnedAt).toLocaleDateString()}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BadgesTab;
